import styled from 'styled-components';
import Text from 'shared/components/Text/Text';
import ModalBodyType from './types';

const getModalWrapperWidth = (modalBodyType: ModalBodyType) => {
  switch (modalBodyType) {
    case ModalBodyType.LEGAL:
      return '614px';
    case ModalBodyType.VERIFICATION:
      return '419px';
    case ModalBodyType.SUCCESS:
      return '462px';
    default:
      return '100%';
  }
};
export const SmsModalWrapper = styled.div<{ $modalBodyType: ModalBodyType }>`
  ${({ theme, $modalBodyType }) => `
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  align-items: flex-start;
  background: ${theme.colors.cardElevationHighWhite};
  padding: 6px 24px 20px 24px;
  align-self: center;
  overflow: auto;

  @media screen and (min-width: ${theme.breakpoints.small}) {
    padding: 14px 24px 20px 24px;
    height: auto;
    width: 614px;
    border-radius: 8px;
    max-width: ${getModalWrapperWidth($modalBodyType)};
  }
`}
`;
export const SmsModalHeaderContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: flex-start;

  justify-content: space-between;
  padding-bottom: 16px;
`;
export const SmsModalHeader = styled(Text)`
  ${({ theme }) => `
  display: flex;
  padding-top: 18px;
  font-size: 20px;
  line-height: 1.4;
  font-weight: 500;

  
  @media screen and (min-width: ${theme.breakpoints.small}) {
    font-size: 24px;
    line-height: 1.5;
    padding-left: 8px;
  }
`}
`;
